import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    createRes: null,
    getAllRes: null,
    getByIdRes: null,
    updateRes: null,
    addMaintenanceRes: null,
    addCalibrationRes: null,
    addDowntimeRes: null,
};

const slice = createSlice({
    name: 'labEquipment',
    initialState,
    reducers: {
        createLabEquipmentRequest: (state) => { state.loading = true; },
        createLabEquipmentSuccess: (state, action) => { state.loading = false; state.createRes = action.payload; },
        createLabEquipmentFailure: (state, action) => { state.loading = false; state.createRes = action.payload; },
        resetCreateLabEquipment: (state) => { state.createRes = null; },

        getAllLabEquipmentRequest: (state) => { state.loading = true; },
        getAllLabEquipmentSuccess: (state, action) => { state.loading = false; state.getAllRes = action.payload; },
        getAllLabEquipmentFailure: (state, action) => { state.loading = false; state.getAllRes = action.payload; },
        resetGetAllLabEquipment: (state) => { state.getAllRes = null; },

        getByIdLabEquipmentRequest: (state) => { state.loading = true; },
        getByIdLabEquipmentSuccess: (state, action) => { state.loading = false; state.getByIdRes = action.payload; },
        getByIdLabEquipmentFailure: (state, action) => { state.loading = false; state.getByIdRes = action.payload; },
        resetGetByIdLabEquipment: (state) => { state.getByIdRes = null; },

        updateLabEquipmentRequest: (state) => { state.loading = true; },
        updateLabEquipmentSuccess: (state, action) => { state.loading = false; state.updateRes = action.payload; },
        updateLabEquipmentFailure: (state, action) => { state.loading = false; state.updateRes = action.payload; },
        resetUpdateLabEquipment: (state) => { state.updateRes = null; },

        addMaintenanceRequest: (state) => { state.loading = true; },
        addMaintenanceSuccess: (state, action) => { state.loading = false; state.addMaintenanceRes = action.payload; },
        addMaintenanceFailure: (state, action) => { state.loading = false; state.addMaintenanceRes = action.payload; },
        resetAddMaintenance: (state) => { state.addMaintenanceRes = null; },

        addCalibrationRequest: (state) => { state.loading = true; },
        addCalibrationSuccess: (state, action) => { state.loading = false; state.addCalibrationRes = action.payload; },
        addCalibrationFailure: (state, action) => { state.loading = false; state.addCalibrationRes = action.payload; },
        resetAddCalibration: (state) => { state.addCalibrationRes = null; },

        addDowntimeRequest: (state) => { state.loading = true; },
        addDowntimeSuccess: (state, action) => { state.loading = false; state.addDowntimeRes = action.payload; },
        addDowntimeFailure: (state, action) => { state.loading = false; state.addDowntimeRes = action.payload; },
        resetAddDowntime: (state) => { state.addDowntimeRes = null; },
    }
});

export const {
    createLabEquipmentRequest, createLabEquipmentSuccess, createLabEquipmentFailure, resetCreateLabEquipment,
    getAllLabEquipmentRequest, getAllLabEquipmentSuccess, getAllLabEquipmentFailure, resetGetAllLabEquipment,
    getByIdLabEquipmentRequest, getByIdLabEquipmentSuccess, getByIdLabEquipmentFailure, resetGetByIdLabEquipment,
    updateLabEquipmentRequest, updateLabEquipmentSuccess, updateLabEquipmentFailure, resetUpdateLabEquipment,
    addMaintenanceRequest, addMaintenanceSuccess, addMaintenanceFailure, resetAddMaintenance,
    addCalibrationRequest, addCalibrationSuccess, addCalibrationFailure, resetAddCalibration,
    addDowntimeRequest, addDowntimeSuccess, addDowntimeFailure, resetAddDowntime,
} = slice.actions;

export default slice.reducer;
